
import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { year: 2010, category1: 10, category2: 5, category3: 2 },
  { year: 2011, category1: 50, category2: 20, category3: 10 },
  { year: 2012, category1: 80, category2: 40, category3: 20 },
  { year: 2013, category1: 30, category2: 60, category3: 30 },
  { year: 2014, category1: 140, category2: 30, category3: 60 },
  { year: 2015, category1: 100, category2: 50, category3: 80 },
  { year: 2016, category1: 20, category2: 10, category3: 40 },
  { year: 2017, category1: 10, category2: 5, category3: 10 },
];

const CustomAreaChart = () => {
  return (
    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Area type="monotone" dataKey="category1" stroke="#00bcd4" fill="#00bcd4" fillOpacity={0.5} />
          <Area type="monotone" dataKey="category2" stroke="#ffab91" fill="#ffab91" fillOpacity={0.5} />
          <Area type="monotone" dataKey="category3" stroke="#7986cb" fill="#7986cb" fillOpacity={0.5} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomAreaChart;
